(function () {
    'use strict';
    app.controller('adminTeamManagementController', ['$filter', '$scope', '$location', '$cookies', 'progressBarService', '$rootScope', '$timeout', '$routeParams', 'adminTeamManagementService', '$http', 'storeUploadService', 'DataManagementService', function ($filter, $scope, $location, $cookies, progressBarService, $rootScope, $timeout, $routeParams, adminTeamManagementService, $http, storeUploadService, dataManagementService) {

        if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined || getLocalValue('userRole') != 'SAdmin') {
            $location.path('/login');
            return false;
        }

        var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;
        $scope.adminID = getLocalValue("emailId");
        $scope.isSAdmin = getLocalValue('userRole') == 'SAdmin' ? true : false;
        $scope.isTeamManagementPage = true;

        $scope.reset = function () {
            $scope.isAccordionHide = true;
            $scope.AffiliationAdmins = [];
            $scope.teamUsers = [];

            $scope.pagination = {
                currentPage: 1,
                itemsPerPage: 10,
                totalRows: 0,
                sortBy: 'eSpectraTeamMemberEmail',
                reverse: false
            }

            $scope.teamAdminPagination = {
                currentPage: 1,
                itemsPerPage: 5,
                totalRows: 0,
                sortBy: 'eSpectraLastUpdateTS',
                reverse: false
            }

            $scope.teamMemberPagination = {
                currentPage: 1,
                itemsPerPage: 5,
                totalRows: 0,
                sortBy: 'eSpectraLastUpdateTS',
                reverse: false
            }

            $scope.models = {
                name: '',
                email: '',
                affiliation: '',
                admininstrator: true,
                active: true,
                suspended: true,
                unactivated: true,
                deprecated: false,
            }
        }

        $scope.reset();
        //team data
        $scope.showSavebtn = true;
        $scope.teamCurrentPage = 1;
        $scope.teamPagingInfo = {
            pageNo: 1,
            itemsPerPage: 10,
            sortBy: 'eSpectraObjectUploadedDate',
            reverse: true
        };

        $scope.teamDataSort = function (sortBy) {
            if (sortBy === $scope.teamPagingInfo.sortBy) {
                $scope.teamPagingInfo.reverse = !$scope.teamPagingInfo.reverse;
            } else {
                $scope.teamPagingInfo.sortBy = sortBy;
                $scope.teamPagingInfo.reverse = false;
            }
        };

        $scope.teamSetPage = function (pageNo) {
            $scope.teamCurrentPage = pageNo;
        };

        $('#referencedArticle').keyup(function () {
            var _this = $(this);
            storeUploadService.validateReferenceArticle(_this, $scope);
        })

        $scope.onFileShareSelected = function (value) {
            storeUploadService.onFileShareSelected(value);
        };

        $scope.clear = function () {
            $scope.message = '';
            $scope.isError = false;
            $scope.isSuccess = false;

            $scope.modalMessage = '';
            $scope.isModalError = false;
            $scope.isModalSuccess = false;

            $scope.teamModalMessage = '';
            $scope.isTeamModalError = false;
            $scope.isTeamModalSuccess = false;

            $scope.FileSelected = false;
            $scope.files = [];

            $scope.SelectedObjectID = 0;

            $("input[type=file]").val('').clone(true);
            $('.border-red').removeClass('border-red');

            $scope.dataManagementValues();

            $scope.dataManagementUpload.$setPristine();
            $scope.dataManagementUpload.$setUntouched();
        }

        $scope.EditTeamData = function (objectData) {
            $scope.clear();
            $scope.isEditData = true;
            $scope.validDOI = true;

            $scope.eSpectraObjectID = objectData.eSpectraObjectID;
            $scope.eSpectraObjectDataSetName = objectData.eSpectraObjectDataSetName;
            $scope.dataManagement.HostMaterial = objectData.eSpectraSpecimenHostMaterial;
            $scope.dataManagement.ChemicalName = objectData.eSpectraSpecimenChemicalName;
            $scope.dataManagement.ReferencedArticle = objectData.eSpectraObjectDOI;
            $scope.dataManagement.Techinque = objectData.eSpectraObjectTechnique;
            $scope.dataManagement.Description = objectData.eSpectraObjectComment;
            $scope.dataManagement.FirstName = objectData.firstName;
            $scope.dataManagement.LastName = objectData.lastName;
            $scope.dataManagement.eSpectraObjectCalibration = objectData.eSpectraObjectCalibration;
            $scope.dataManagement.FileShare = objectData.eSpectraObjectShareType.toLowerCase();
            $scope.dataManagement.isPublic = objectData.eSpectraObjectShareType.toLowerCase() == "public" ? 1 : 0;
            $scope.isTeamMember = true;

            $('#upload').modal('show');
        }

        $scope.update = function () {

            progressBarService.showProgressBar();

            var data = {
                eSpectraObjectID: $scope.eSpectraObjectID,
                eSpectraObjectDataSetName: $scope.eSpectraObjectDataSetName,
                eSpectraSpecimenHostMaterial: $scope.dataManagement.HostMaterial,
                eSpectraSpecimenChemicalName: $scope.dataManagement.ChemicalName,
                ReferencedArticle: $scope.dataManagement.ReferencedArticle,
                eSpectraObjectTechnique: $scope.dataManagement.Techinque,
                eSpectraObjectDesc: $scope.dataManagement.Description,
                FirstName: $scope.dataManagement.FirstName,
                LastName: $scope.dataManagement.LastName,
                //eSpectraLastUpdateUserID: $cookies.get("UserId"),
                eSpectraObjectDOI: $scope.dataManagement.ReferencedArticle,
                eSpectraObjectCalibration: $scope.dataManagement.eSpectraObjectCalibration,
                eSpectraObjectShareType: $scope.dataManagement.FileShare
            }

            dataManagementService.updateDatamanagement(data).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.modalMessage = response.data.message;
                    $scope.isModalError = true;
                    $scope.isModalSuccess = false;
                    //$timeout(hideMessage, 10000);
                }
                else {

                    //var data = JSON.parse(response.data);
                    if (response.data) {
                        $scope.isTeamModalError = false;
                        $scope.isTeamModalSuccess = true;
                        $scope.teamModalMessage = GetMessage.dataUpdatedSuccessfully;
                    }
                    else {
                        $scope.teamModalMessage = GetMessage.UploadFileIntoElasticSearchFailed;
                        $scope.isTeamModalError = true;
                        $scope.isTeamModalSuccess = false;
                    }

                    //$timeout(hideMessage, 10000);
                    $('#upload').modal('toggle');
                    $('.border-red').removeClass('border-red');
                    $scope.getTeamDataObjects($scope.eSpectraTeamPartyID);

                }
            });
            progressBarService.hideProgressBar();
        };

        $scope.deleteValidate = function (data) {
            $scope.isTeamModalError = false;
            $scope.isTeamModalSuccess = false;
            $scope.teamModalMessage = '';
            $("#confirmDelete").modal('toggle');
            $("#data-del-no-btn").focus();

            $scope.objects = [];
            $scope.fileNames = [];

            $scope.objects.push(data.eSpectraObjectID);
            $scope.fileNames.push(data.eSpectraObjectDataSetName);
        }

        $scope.deleteData = function () {
            $("#confirmDelete").modal('toggle');
            progressBarService.showProgressBar();

            dataManagementService.deleteFile($scope.objects.join(), $scope.fileNames.join()).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.teamModalMessage = response.data.message;
                    $scope.isTeamModalError = true;
                    $scope.isTeamModalSuccess = false;
                }
                else {
                    if (response.data) {
                        $scope.isTeamModalError = false;
                        $scope.isTeamModalSuccess = true;
                        $scope.teamModalMessage = GetMessage.dataDeletedSuccessfully;
                    }
                    else {
                        $scope.teamModalMessage = GetMessage.UploadFileIntoElasticSearchFailed;
                        $scope.isTeamModalError = true;
                        $scope.isTeamModalSuccess = false;
                    }
                    //$timeout(hideMessage, 10000);
                    $scope.getTeamDataObjects($scope.eSpectraTeamPartyID);
                }
            });
            $scope.objects = [];
            $scope.fileNames = [];
            progressBarService.hideProgressBar();
        };

        $scope.getTeamDataObjects = function (id) {
            callTeamDataObjectsAPI(id);
        };

        function callTeamDataObjectsAPI(id) {
            $.ajax({
                url: serviceBase + 'api/super/teamDataObjects/' + id,
                async: false,
                type: "GET",
                dataType: "json",
                data: {}
            }).success(function (data) {
                $scope.dataManagementDetails = data;
                $scope.totalNumberTeamRecords = $scope.dataManagementDetails.teamManagementFiles.length;
            }).error(function (data, status) {
                scope.message = GetMessage.ApiError;
                scope.isError = true;
                scope.isSuccess = false;
            });
        }

        //end: team data
        $scope.activeTab = 1;

        $scope.setTab = function (tabNum) {
            $scope.activeTab = tabNum;
        }
        $scope.isSet = function (tabNum) {
            return $scope.activeTab == tabNum;
        }

        $scope.setPage = function (currentPage) {
            $scope.pagination.currentPage = currentPage;
            $scope.getData();
        }

        $scope.sortTeam = function (sortBy) {
            if ($scope.teamUsers.length > 0) {
                $scope.pagination.sortBy = sortBy;
                $scope.pagination.currentPage = 1;
                $scope.pagination.reverse = !$scope.pagination.reverse;
                $scope.getData();
            }
        }

        $scope.getData = function (click) {
            progressBarService.showProgressBar();
            if (click == "search") {
                $scope.users = [];
                $scope.pagination.currentPage = 1;
                $scope.pagination.sortBy = 'eSpectraTeamMemberEmail';
                $scope.pagination.reverse = false;
            }

            var data = {
                PageNo: $scope.pagination.currentPage,
                SortBy: $scope.pagination.sortBy,
                Reverse: $scope.pagination.reverse ? 'desc' : 'asc',
                eSpectraTeamAdminFirstName: $scope.models.name,
                eSpectraTeamAdminEmail: $scope.models.email,
                eSpectraTeamAffiliationName: $scope.models.affiliation,
                Administrator: $scope.models.admininstrator ? '1' : '0',
                Active: $scope.models.active ? 'active' : '0',
                Suspended: $scope.models.suspended ? 'suspended' : '0',
                Unactivated: $scope.models.unactivated ? 'pending' : '0',
                Deprecated: $scope.models.deprecated ? 'deprecated' : '0'
            }

            adminTeamManagementService.getTeamData(data).then(function (response) {
                $scope.isAccordionHide = false;
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    $scope.teamUsers = response.data.eSpectraTeam;
                    if ($scope.teamUsers.length > 0) {
                        $scope.pagination.totalRows = $scope.teamUsers[0].totalNumberOfRecords;
                    }
                }
                $scope.closeEditUserProfileModal();
                progressBarService.hideProgressBar();
            });
        }

        $scope.exportReportData = function () {
            progressBarService.showProgressBar();
            $scope.getCurrentDate();
            var data = {
                PageNo: $scope.pagination.currentPage,
                SortBy: $scope.pagination.sortBy,
                Reverse: $scope.pagination.reverse ? 'desc' : 'asc',
                eSpectraAdminName: $scope.models.name,
                eSpectraTeamAdminEmail: $scope.models.email,
                eSpectraTeamAffiliationName: $scope.models.affiliation,
                Administrator: $scope.models.admininstrator ? '1' : '0',
                Active: $scope.models.active ? 'active' : '0',
                Suspended: $scope.models.suspended ? 'suspended' : '0',
                Unactivated: $scope.models.unactivated ? 'pending' : '0',
                Deprecated: $scope.models.deprecated ? 'deprecated' : '0'
            }

            adminTeamManagementService.getTeamDataReport(data).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    //$timeout(hideMessage, 10000);
                }
                else {
                    var csv = convertArrayOfObjectsToCSV({
                        data: response.data
                    });

                    BlobDownloadCSV('TeamManagementReport_' + $scope.currentDate + '.csv', csv)
                }

                progressBarService.hideProgressBar();
            });
        }

        $scope.getCurrentDate = function () {
            var today, dd, mm, yyyy, currentDate, startDate, endDate, parameter;
            today = new Date();
            dd = today.getDate();
            mm = today.getMonth() + 1; //January is 0!

            yyyy = today.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            $scope.currentDate = mm + '/' + dd + '/' + yyyy;
        }

        function convertArrayOfObjectsToCSV(args) {

            var result, ctr, keys, columnDelimiter, lineDelimiter, data, headers;

            data = args.data || null;
            if (data == null || !data.length) {
                return null;
            }

            columnDelimiter = args.columnDelimiter || ',';
            lineDelimiter = args.lineDelimiter || '\n';


            keys = Object.keys(data[0]).slice(1);

            headers = ["Affiliation Name",
                    "Team Display Name",
                    "Email",
                    "Admin Name",
                    "Start/End Date",
                    "Seats Remaining"]

            result = 'Report Name' + columnDelimiter + "Team Management Report" + lineDelimiter;
            result += headers.join(columnDelimiter);
            result += lineDelimiter;

            data.forEach(function (item) {

                ctr = 0;
                keys.forEach(function (key) {
                    if (ctr > 0) result += columnDelimiter;

                    result += item[key];
                    ctr++;
                });
                result += lineDelimiter;
            });

            return result;
        }

        $scope.displayEditProfileModal = function (index, teamUser, tabNum) {
            $scope.setTab(tabNum);

            $scope.isDisabled = false;
            $scope.isNullValue = false;
            $scope.isInvalidAdminID = false;
            $scope.startIndex = 0;

            $scope.teamModalMessage = '';
            $scope.isTeamError = false;
            $scope.isTeamSuccess = false;

            $scope.teamMessage = ''
            $scope.isTeamModalError = false;
            $scope.isTeamModalSuccess = false;

            $scope.removeTeamMemberEmailIds = '';
            $scope.userDetailscurrentPage = 0;
            $scope.userDetailsPageSize = 5;
            $scope.teamAdminPagination = {
                currentPage: 1,
                itemsPerPage: 5,
                totalRows: 0,
                sortBy: 'eSpectraLastUpdateTS',
                reverse: false
            }
            $scope.teamMemberPagination = {
                currentPage: 1,
                itemsPerPage: 5,
                totalRows: 0,
                sortBy: 'eSpectraLastUpdateTS',
                reverse: false
            }
            $scope.additinalUser = [{ firstName: '', lastName: '', email: '', startDate: '', isShowPlus: true }];
            $scope.selectedInstitute = {
                InstitutionId: 0,
                InstitutionName: '',
                isAffiliationExists: false,
                userDefinedAffiliation: ''
            };
            $scope.closeTeamMessageBar();

            adminTeamManagementService.getTeamDetailsByTeamID(teamUser.eSpectraTeamPartyID).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    $scope.team = response.data;
                    $scope.eSpectraTeamPartyID = teamUser.eSpectraTeamPartyID;
                    //for institution popup
                    $scope.profileData = {
                        eSpectraTeamAffiliationName: $scope.team.eSpectraTeamAffiliationName,
                        eSpectraTeamAffiliationID: $scope.team.eSpectraTeamAffiliationID,
                        eSpectraOrigTeamAffiliationName: $scope.team.eSpectraTeamAffiliationName
                    }
                    $scope.advantageAccountDefaultValue = $scope.team.advAccntNum;
                    $scope.team.oldeSpectraTeamName = $scope.team.eSpectraTeamName;
                    $scope.team.eSpectraSeatsRemaining = $scope.team.eSpectraSeatsAllocated + '/' + $scope.team.eSpectraOrderQty;
                    $scope.team.eSpectraOrigTeamAffiliationName = $scope.team.eSpectraTeamAffiliationName;
                    $scope.team.isKratosData = $scope.team.isKratosData == 1 ? true : false;
                    $scope.team.oldeIsKratosData = $scope.team.isKratosData;
                    $scope.getTeamDataObjects(teamUser.eSpectraTeamPartyID);
                    $scope.getTeamAdminData(false);

                }
            });
            $scope.isAffiliationChanged = false;
            $scope.isTeamNameChanged = false;
            $scope.isKratosDataAccessChanged = false;
            $scope.isAffiliationDivActive = false;
        }

        $scope.getTeamAdminData = function (isSort) {
            var data = {
                eSpectraTeamPartyID: $scope.team.eSpectraTeamPartyID,
                PageNo: $scope.teamAdminPagination.currentPage,
                SortBy: $scope.teamAdminPagination.sortBy,
                Reverse: $scope.teamAdminPagination.reverse ? 'desc' : 'asc',
            }
            adminTeamManagementService.getTeamAdminData(data).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    $scope.teamAdminData = response.data;
                    $scope.isShowAdminNameTextField = false;
                    $scope.isShowAdminEmailTextField = false;
                    $scope.isRemoveAdminDisable = false;
                    angular.forEach($scope.teamAdminData, function (value, key) {
                        $scope.teamAdminData[key].isSetAsUser = false;
                    });
                    if (!isSort) {
                        $scope.getTeamMemberData(false);
                    }
                }
            });
        }

        $scope.getTeamMemberData = function (isSort) {
            var data = {
                eSpectraTeamPartyID: $scope.team.eSpectraTeamPartyID,
                eSpectraTeamMemberName: '',
                eSpectraTeamMemberEmail: '',
                eSpectraTeamAffiliationName: '',
                Administrator: '1',
                Active: 'active',
                Expired: '0',
                Pending: 'pending',
                PageNo: $scope.teamMemberPagination.currentPage,
                SortBy: $scope.teamMemberPagination.sortBy,
                Reverse: $scope.teamMemberPagination.reverse ? 'desc' : 'asc',
            }
            adminTeamManagementService.getTeamMemberData(data).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    $scope.teamMemberData = response.data;
                    angular.forEach($scope.teamMemberData, function (value, key) {
                        $scope.teamMemberData[key].isRenew = false;
                        $scope.teamMemberData[key].isRenewDisable = false;
                        $scope.teamMemberData[key].isRemoveDisable = false;
                        $scope.teamMemberData[key].isShowNameTextField = false;
                        $scope.teamMemberData[key].isShowEmailTextField = false;
                    });
                    if ($scope.team.eSpectraOrderQty != $scope.teamMemberData.length) {
                        var startIndex = $scope.teamMemberData.length;
                        var remainingQty = $scope.team.eSpectraOrderQty - $scope.teamMemberData.length
                        for (var i = startIndex; i < startIndex + remainingQty; i++) {
                            $scope.teamMemberData.push({
                                srNo: i + 1,
                                eSpectraTeamMemberName: '',
                                eSpectraTeamMemberEmail: '',
                                eSpectraOrderStartDate: $scope.teamAdminData[0].eSpectraOrderStartDate,
                                eSpectraOrderEndDate: $scope.teamAdminData[0].eSpectraOrderEndDate,
                                isRenew: false,
                                isRenewDisable: true,
                                isRemoveDisable: true,
                                isShowNameTextField: true,
                                isShowEmailTextField: true,

                            });
                        }
                    }
                    if (!isSort) {
                        $scope.getcountryData();
                    }
                }
            });
        }

        $scope.getcountryData = function () {
            $http({
                method: 'Get',
                url: serviceBase + "country",
                headers: {
                    'Content-Type': 'application/json'
                }
            }).success(function (data, status) {
                if (data != null && data.message != undefined) {
                    $scope.message = data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    $scope.countries = data;
                    $scope.team.eSpectraCountryID = '1';
                    $('#editUserProfileModal').modal('show');
                }
            }).error(function (data, status) {
            })

        }

        $scope.selectAffiliation = function () {

            $('#affiliationName').val('');
            $scope.isAffiliationDivActive = true;
            $scope.selectedInstitute.userDefinedAffiliation = "";
            $scope.selectedInstitute.InstitutionId = $scope.profileData.eSpectraTeamAffiliationID;
            if (!$scope.selectedInstitute.isAffiliationExists) {
                $scope.selectedInstitute.InstitutionName = $scope.profileData.eSpectraTeamAffiliationName;
            } else {
                if ($scope.profileData.eSpectraTeamAffiliationName.length == 0) {
                    $scope.selectedInstitute.isAffiliationExists = false;
                    //$('#affiliationName').removeAttr('disabled');
                }
                $scope.selectedInstitute.userDefinedAffiliation = $scope.profileData.eSpectraTeamAffiliationName;
            }

            $('#affiliation').modal('show');
        }

        $scope.sortTeamMembers = function (sortBy) {
            if ($scope.teamMemberData.length > 0) {
                $scope.teamMemberPagination.sortBy = sortBy;
                $scope.teamMemberPagination.currentPage = 1;
                $scope.teamMemberPagination.reverse = !$scope.teamMemberPagination.reverse;
                $scope.getTeamMemberData(true);
            }
        }

        $scope.sortTeamAdmins = function (sortBy) {
            if ($scope.teamAdminData.length > 0) {
                $scope.teamAdminPagination.sortBy = sortBy;
                $scope.teamAdminPagination.currentPage = 1;
                $scope.teamAdminPagination.reverse = !$scope.teamAdminPagination.reverse;
                $scope.getTeamAdminData(true);
            }
        }

        $scope.addFields = function () {
            if ($scope.additinalUser.length < 3) {
                $scope.additinalUser.push({
                    firstName: '', lastName: '', email: '', startDate: '', isShowPlus: false
                });
            }
        }

        $scope.removeField = function (index) {
            if (!(($scope.additinalUser[index].firstName != '' && $scope.additinalUser[index].lastName != '' && $scope.additinalUser[index].email != '') || ($scope.additinalUser[index].firstName == '' && $scope.additinalUser[index].lastName == '' && $scope.additinalUser[index].email == ''))) {
                $scope.isNullValue = false;
                $scope.isDisabled = false;
            }
            $scope.additinalUser.splice(index, 1);
        }

        $scope.removeTeamMember = function (index) {
            $scope.removeTeamMemberEmailIds = $scope.removeTeamMemberEmailIds + $scope.teamMemberData[index].eSpectraTeamMemberEmail + ',';
            $scope.teamMemberData.splice(index, 1);
        }

        $scope.removeTeamAdmin = function (index) {
            $scope.teamAdminData[0].eSpectraTeamMemberName = '';
            $scope.teamAdminData[0].eSpectraTeamMemberEmail = '';
            $scope.isShowAdminNameTextField = true;
            $scope.isShowAdminEmailTextField = true;
            $scope.isRemoveAdminDisable = true;
            //$scope.removeTeamMemberEmailIds = $scope.removeTeamMemberEmailIds + $scope.teamAdminData[index].eSpectraTeamMemberEmail + ',';
            //$scope.teamAdminData.splice(index, 1);
        }

        $scope.saveAdminUpdatedTeamProfile = function () {
            var invalidDataCount = 0;
            angular.forEach($scope.teamMemberData, function (value, key) {
                if ((value.eSpectraTeamMemberName == '' && value.eSpectraTeamMemberEmail != '') || (value.eSpectraTeamMemberName != '' && value.eSpectraTeamMemberEmail == '')) {
                    invalidDataCount++;
                    if (value.eSpectraTeamMemberName == '') {
                        $('#memberName_' + key).addClass('border-red');
                    }
                    if (value.eSpectraTeamMemberEmail == '') {
                        $('#memberEmail_' + key).addClass('border-red');
                    }
                }
            });
            if ($scope.isShowAdminNameTextField == true && $scope.teamAdminData[0].eSpectraTeamMemberName == '' && $scope.teamAdminData[0].eSpectraTeamMemberEmail == '') {
                invalidDataCount++;
                $('#adminName_0').addClass('border-red');
                $('#adminEmail_0').addClass('border-red');
                $scope.teamMessage = 'You are not allowed to remove the admin unless another admin is present.';
                $scope.isTeamError = true;
                $scope.isTeamSuccess = false;
            } else if ($scope.isShowAdminNameTextField == true && $scope.teamAdminData[0].eSpectraTeamMemberName == '' && $scope.teamAdminData[0].eSpectraTeamMemberEmail != '') {
                invalidDataCount++;
                $('#adminName_0').addClass('border-red');
                $('#adminEmail_0').removeClass('border-red');
            } else if ($scope.isShowAdminNameTextField == true && $scope.teamAdminData[0].eSpectraTeamMemberName != '' && $scope.teamAdminData[0].eSpectraTeamMemberEmail == '') {
                invalidDataCount++;
                $('#adminEmail_0').addClass('border-red');
                $('#adminName_0').removeClass('border-red');
            }

            if ($scope.isInvalidAdminID) {
                invalidDataCount++;
                $('#adminEmail_0').addClass('border-red');
            }

            if ($scope.isAffiliationChanged && $scope.selectedInstitute.userDefinedAffiliation.length > 0 && $scope.team.eSpectraCountryID == 1) {
                $('#country').addClass('border-red');
            } else if (invalidDataCount == 0) {
                progressBarService.showProgressBar();
                $('#country').removeClass('border-red');
                var isAdvantageAccountChanged = false;

                var removed = $scope.removeTeamMemberEmailIds.split(',');
                var eSpectraMembers = [];

                angular.forEach(removed, function (value, key) {
                    eSpectraMembers.push({ eSpectraTeamMemberEmail: value, isRemoved: 1, eSpectraTeamPartyID: $scope.team.eSpectraTeamPartyID });
                });

                if ($scope.team.oldeSpectraTeamName != $scope.team.eSpectraTeamName) {
                    $scope.isTeamNameChanged = true;
                }

                if ($scope.team.oldeIsKratosData != $scope.team.isKratosData) {
                    $scope.isKratosDataAccessChanged = true;
                }

                if ($scope.advantageAccountDefaultValue == "" && $scope.team.advAccntNum.length > 0) {
                    isAdvantageAccountChanged = true;
                }

                var teamMemberList = [], tempName = [];
                if ($scope.isShowAdminNameTextField == true && $scope.teamAdminData[0].eSpectraTeamMemberName != '' && $scope.teamAdminData[0].eSpectraTeamMemberEmail != '') {
                    tempName = $scope.teamAdminData[0].eSpectraTeamMemberName.split(' ')

                    eSpectraMembers.push({
                        eSpectraTeamMemberFirstName: tempName[0],
                        eSpectraTeamMemberLastName: tempName[1],
                        eSpectraTeamMemberEmail: $scope.teamAdminData[0].eSpectraTeamMemberEmail,
                        iseSpectraTeamAdmin: '1',
                        isAdded: 1,
                        eSpectraTeamPartyID: $scope.team.eSpectraTeamPartyID
                    });
                }

                angular.forEach($scope.teamMemberData, function (value, key) {
                    tempName = value.eSpectraTeamMemberName.split(' ')
                    if (value.eSpectraTeamMemberName != "" && value.eSpectraTeamMemberEmail != "" && value.isShowNameTextField == true) {

                        eSpectraMembers.push({
                            eSpectraTeamMemberFirstName: tempName[0],
                            eSpectraTeamMemberLastName: tempName[1],
                            eSpectraTeamMemberEmail: value.eSpectraTeamMemberEmail,
                            iseSpectraTeamAdmin: '0',
                            isAdded: 1,
                            eSpectraTeamPartyID: $scope.team.eSpectraTeamPartyID
                        });
                    }
                });

                var teamProfileData = {
                    eSpectraInstitutionID: $scope.team.eSpectraOrigPartyID,
                    InstitutionName: $scope.profileData.eSpectraTeamAffiliationName,
                    RgoldID: $scope.profileData.eSpectraTeamAffiliationID,
                    eSpectraCountryID: $scope.team.eSpectraCountryID,
                    AdvAccntNum: $scope.team.advAccntNum,
                    isAdvantageAccountChanged: isAdvantageAccountChanged,
                    isAffiliationChanged: $scope.isAffiliationChanged,
                    eSpectraTeam: [{
                        eSpectraTeamName: $scope.team.eSpectraTeamName,
                        isTeamNameChanged: $scope.isTeamNameChanged,
                        isKratosDataAccessChanged: $scope.isKratosDataAccessChanged,
                        isKratosData: $scope.team.isKratosData ? 1 : 0,
                        eSpectraTeamPartyID: $scope.team.eSpectraTeamPartyID,
                        eSpectraTeamMember: eSpectraMembers
                    }]
                }

                adminTeamManagementService.saveAdminUpdatedTeamProfile(teamProfileData).then(function (response) {
                    if (response != null && response.data.message != undefined) {
                        $scope.teamModalMessage = response.data.message;
                        $scope.isTeamModalError = true;
                        $scope.isTeamModalSuccess = false;
                    }
                    else {
                        $scope.message = "Profile has been updated successfully for team '" + $scope.team.eSpectraTeamName + "'";
                        $scope.isError = false;
                        $scope.isSuccess = true;
                        $scope.removeTeamMemberEmailIds = "";
                        $scope.getData();
                    }
                    progressBarService.hideProgressBar();
                });
            }

        };

        $scope.checkValidEmail = function (event, index) {
            index = $scope.userDetailscurrentPage * $scope.userDetailsPageSize + index;
            var count = 0, i, emailregx, validIndices = [], invalidIndices = [];
            emailregx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if ($(event.currentTarget).val() == $scope.adminID || $(event.currentTarget).val() == $scope.teamAdminData[0].eSpectraTeamMemberEmail) {
                $scope.isDisabled = true;
            } else {
                $scope.isDisabled = false;
            }

            for (i = $scope.startIndex ; i < $scope.teamMemberData.length; i++) {
                if ($scope.teamMemberData[i].eSpectraTeamMemberEmail == $scope.adminID) {
                    $scope.isDisabled = true;
                    return false;
                } else if ($scope.teamMemberData[i].eSpectraTeamMemberEmail != "" && $scope.teamMemberData[i].eSpectraTeamMemberEmail != undefined) {
                    if (emailregx.test($scope.teamMemberData[i].eSpectraTeamMemberEmail)) {
                        validIndices.push(i);
                    }
                    else {
                        invalidIndices.push(i);
                    }
                } else {
                    $('#memberEmail_' + i).removeClass('border-red');
                }
            }
            if (invalidIndices.length > 0) {
                for (var i = 0; i < invalidIndices.length; i++) {
                    $('#memberEmail_' + invalidIndices[i]).addClass('border-red');
                }
            }

            if (validIndices.length > 0) {
                for (var i = 0; i < validIndices.length; i++) {
                    $('#memberEmail_' + validIndices[i]).removeClass('border-red');
                }
            }

            if (!(invalidIndices.length > 0)) {
                $scope.isDisabled = false;
                $scope.checkDuplicateEmailIDS();
            } else {
                if ($scope.teamMemberData.length >= 1) {

                    $scope.isDisabled = true;
                }
            }
        }

        $scope.checkValidAdminEmail = function (event, emailID) {
            var emailregx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if ($(event.currentTarget).val() == $scope.adminID || $(event.currentTarget).val() == emailID) {
                $scope.isInvalidAdminID = true;
            } else {
                $scope.isInvalidAdminID = false;
            }
            if (emailID != "" && emailID != undefined) {
                if (emailregx.test(emailID)) {
                    $('#adminEmail_0').removeClass('border-red');
                    $scope.isInvalidAdminID = false;
                }
                else {
                    $scope.isInvalidAdminID = true;
                    $('#adminEmail_0').addClass('border-red');
                }
            } else if (emailID == undefined) {
                $('#adminEmail_0').addClass('border-red');
                $scope.isInvalidAdminID = true;
            }
            else {
                $('#adminEmail_0').removeClass('border-red');
                $scope.isInvalidAdminID = false;
            }
        }

        $scope.checkDuplicateEmailIDS = function () {
            for (var i = 0; i < $scope.teamMemberData.length; i++) {
                for (var x = i + 1; x < $scope.teamMemberData.length; x++) {
                    if ($scope.teamMemberData[i].eSpectraTeamMemberEmail != "" && $scope.teamMemberData[i].eSpectraTeamMemberEmail == $scope.teamMemberData[x].eSpectraTeamMemberEmail) {
                        $scope.isDisabled = true;
                        return false;
                    }
                    else {
                        $scope.isDisabled = false;
                    }
                }
            }
        }

        $scope.checkNullValue = function (index) {
            index = $scope.userDetailscurrentPage * $scope.userDetailsPageSize + index;
            if ($('#memberName_' + index).hasClass('border-red') && $scope.teamMemberData[index].eSpectraTeamMemberEmail != '') {
                $('#memberName_' + index).removeClass('border-red');
            }
        }

        $scope.showNextUserDetailsPage = function () {
            $scope.userDetailscurrentPage = $scope.userDetailscurrentPage + 1;
        }

        $scope.closeTeamMessageBar = function () {
            $scope.teamMessage = "";
            $scope.isTeamError = false;
            $scope.isTeamSuccess = false;
        }

        $scope.closeEditUserProfileModal = function () {
            $('#editUserProfileModal').modal('hide');
            $('div.modal-backdrop').remove();
        }
    }]);
})();